module.exports = __webpack_public_path__ + "static/img/00413v.41fa6ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00413v.jpg
// module id = dv2z
// module chunks = 1